'use client';

/**
 * Next.js Route-Level Error Boundary
 *
 * This error boundary handles errors that occur within specific routes/pages:
 * - Page component render errors
 * - Client component errors within this route
 * - Server component errors during SSR for this route
 * - Errors in nested layouts (but not root layout)
 *
 * When an error occurs, this component:
 * 1. Automatically reports the error to PostHog with detailed context
 * 2. Shows a user-friendly error page with recovery options
 * 3. Provides "Try again" (soft reset) and "Reload page" (hard reset) buttons
 * 4. Displays error details in development mode
 *
 * This file should be placed in route directories to catch errors for that specific route.
 * For app-wide critical errors, see global-error.tsx instead.
 */

import ErrorFallback from '@/lib/posthog/ErrorFallback';

export interface PageErrorProps {
  error: Error & { digest?: string };
  reset: VoidFunction;
}

const PageError = ({ error, reset }: PageErrorProps) => {
  return <ErrorFallback error={error} resetErrorBoundary={reset} />;
};

export default PageError;
